import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
    render() {

        const BLLoanDetails = this.props.BLLoanDetails;
        const LoanReportSearchData = this.props.LoanReportSearchData;

        return (
            <div>

                <h2><center><u>Current BL Loans Report</u></center></h2>
                <div>&nbsp;</div>
                <h3><center>Group :{LoanReportSearchData.groupName}</center></h3>
                <h3><center>Factory :{LoanReportSearchData.factoryName}</center></h3>
                <h3><center>Route :{(LoanReportSearchData.routeName===undefined)?"All Routes":LoanReportSearchData.routeName}</center></h3>
                <div>&nbsp;</div>
                <div>
                    <Box minWidth={1250}>
                        <TableContainer >
                            <Table aria-label="caption table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'center'} style={{  border: "1px #ccc solid", width: "120px"  }}>Route Code</TableCell>
                                        <TableCell align={'center'} style={{  border: "1px #ccc solid", width: "150px"  }}><span style={{whiteSpace:"nowrap"}}>Route Name</span></TableCell>
                                        <TableCell align={'center'} style={{  border: "1px #ccc solid", width: "200px"  }}>Registration Number</TableCell>
                                        <TableCell align={'center'} style={{  border: "1px #ccc solid", width: "300px"  }}>Name</TableCell>
                                        <TableCell align={'center'} style={{  border: "1px #ccc solid", width: "120px"  }}><span style={{whiteSpace:"nowrap"}}>Loan Issued</span> Date</TableCell>
                                        <TableCell align={'center'} style={{  border: "1px #ccc solid", width: "200px"  }}>Principal Amount (Rs.)</TableCell>
                                        <TableCell align={'center'} style={{  border: "1px #ccc solid", width: "120px"  }}>Installments</TableCell>
                                        <TableCell align={'center'} style={{  border: "1px #ccc solid", width: "120px"  }}>Remaining Installments</TableCell>
                                        <TableCell align={'center'} style={{  border: "1px #ccc solid", width: "120px"  }}>Capital Outstanding (Rs.)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {BLLoanDetails.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align={'left'} component="th" scope="row" style={{  border: "1px #ccc solid", width: "120px"  }}>
                                                {data.routeCode}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{  border: "1px #ccc solid", width: "150px"  }}>
                                                {data.routeName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{  border: "1px #ccc solid", width: "200px"  }}>
                                                {data.registrationNumber}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{  border: "1px #ccc solid", width: "300px"  }}>
                                                {data.name}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{  border: "1px #ccc solid", width: "120px"  }}>
                                                {data.loanIssuedDate.split('T')[0]}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{  border: "1px #ccc solid", width: "200px"  }}>
                                                {data.principalAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{  border: "1px #ccc solid", width: "120px"  }}>
                                                {data.numberOfInstalments}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{  border: "1px #ccc solid", width: "120px"  }}>
                                                {data.remainingInstalments}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{  border: "1px #ccc solid", width: "120px"  }}>
                                                {data.capitalOutstanding.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );
    }
}